import type { IERecruiterOffer, IOffer } from '@/types/shared-types'

export default function (offer: IERecruiterOffer): IOffer {
  return {
    id: offer.jobOfferId,
    title: offer.title,
    location: offer.location,
    region: offer.region.name,
    url: offer.urlWithLayout,
    publishedDate: offer.publishDate,
    jobType: offer.additionalFields?.['Rodzaj pracy']?.[0] || '',
  }
}
